module.exports = __webpack_public_path__ + "img/printers.4ad4fcdf.svg";